const permissionsArray = [
  "addClass",
  "editClass",
  "deleteClass",
  "classList",
  "courseList",
  "addCourse",
  "editCourse",
  "deleteCourse",
  "subjectList",
  "addSubject",
  "editSubject",
  "deleteSubject",
  "chapterList",
  "addChapter",
  "editChapter",
  "deleteChapter",
  "topicList",
  "addTopic",
  "editTopic",
  "deleteTopic",
  "levelList",
  "addLevel",
  "editLevel",
  "deleteLevel",
  "questionTypeList",
  "addQuestionType",
  "editQuestionType",
  "deleteQuestionType",
  "examTypeList",
  "addExamType",
  "editExamType",
  "deleteExamType",
];

const permissions = permissionsArray.reduce((acc, permission) => {
  acc[permission] = true;
  return acc;
}, {});

export default permissions;
